/**
 * @file map component
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {maxSpeed, speedStep, colorScale} from './lib/scale';
import { DropTarget } from 'react-dnd';
import {DropFilterMarker} from './actions';
import getCityInfo from './lib/getCityInfo';
const turf = require('@turf/turf');

const div = React.createFactory('div');
const scene = `${process.env.PUBLIC_URL}/basemap.yaml`;

function getStartPointFilter(latLng) {
    const bbox = getStartPointBbox(latLng);
    return {
        start_longitude: {min: bbox[0], max: bbox[2]},
        start_latitude: {min: bbox[1], max: bbox[3]}
    }
}

function getStartPointBbox({lat, lng}) {
    return turf.bbox(turf.buffer(turf.point([lng, lat]), 1, 'kilometers'));
}

class Map extends Component {
    onLayerLoad() {
        const {config} = this.tangramLayer.scene;
        config.layers.strava = this.getLayerConfig();
        this.tangramLayer.scene.updateConfig();
    }
    getLayerConfig() {
        const {
            style,
            styleParamName,
            layerName,
            startFilter,
            city,
            predictedWorkout,
            sequentialColorScale
        } = this.props;
        const layer = {};
        const source = `${city}-${layerName}`
        layer.data = {
            source,
            layer: layerName
        };
        layer.filter = {};

        if (startFilter) {
            Object.assign(layer.filter, getStartPointFilter(startFilter));
        }

        if (predictedWorkout && city === 'brussels') {
            Object.assign(layer.filter, {
                type_prediction: ['t']
            });
        }

        layer.draw = {
            [style]: {
                size: '2.5px',
                width: [[10, '0.75px'], [14, '0.5px']],
                order: 1000,
                color: 'grey',
                collide: false
            }
        };
        if (startFilter && style === 'lines') {
            layer.draw[style].width = [[10, '1px'], [14, '1.5px']];
        }
        for (
            let speed = 0;
            speed <= maxSpeed;
            speed+=speedStep
        ) {
            let filterValue = {
                min: speed
            };
            if (speed < maxSpeed) {
                filterValue.max = speed + speedStep;
            }
            layer['speed' + speed] = {
                filter: {
                    [styleParamName]: filterValue
                },
                draw: {
                    [style]: {
                        // order: 1000 + speed,
                        color: colorScale(speed, sequentialColorScale)
                    }
                }
            }
        }
        return layer;
    }
    componentDidUpdate(prevProps) {
        const {config} = this.tangramLayer.scene;
        const {startFilter, city} = this.props;
        if (config) {
            config.layers.strava = this.getLayerConfig();
            this.tangramLayer.scene.updateConfig();
        }
        if (startFilter !== prevProps.startFilter) {
            if (startFilter) {
                const bbox = getStartPointBbox(startFilter);
                this.filterBboxRectangle.setBounds([
                    [bbox[1], bbox[0]],
                    [bbox[3], bbox[2]],
                ]);
                this.filterBboxRectangle.addTo(this.map);
                this.filterMarker.setLatLng(startFilter);
                this.filterMarker.addTo(this.map);
            } else {
                this.filterMarker.remove();
                this.filterBboxRectangle.remove();
            }
        }
        if (city !== prevProps.city) {
            this.setCityPosition();
        }
    }
    setCityPosition() {
        const {city} = this.props;
        if (city) {
            const {center} = getCityInfo(city);
            this.map.setView(center, 13);
        }
    }
    componentDidMount() {
        const {L, Tangram} = window;
        this.filterMarker = L.marker([], {icon: L.divIcon({
            className: 'anticon anticon-environment Map__filter-icon',
            iconAnchor: [16, 16],
            iconSize: [32, 32]
        })});
        this.filterBboxRectangle = L.rectangle(
            [[0, 0], [0, 0]],
            {
                color: 'red',
                weight: 2,
                fill: false,
                dashArray: '5, 5'
            }
        );
        this.map = L.map(this.mapElement, {
            maxZoom: 20,
            minZoom: 10,
            zoomSnap: 0,
            trackResize: true,
            keyboard: false
        });
        this.setCityPosition();
        this.tangramLayer = Tangram.leafletLayer({
            scene,
            // logLevel: 'debug'
        });
        this.tangramLayer.scene.subscribe({load: () => this.onLayerLoad()})
        this.tangramLayer.addTo(this.map);
    }
    render() {
        const {onnectDropTarget} = this.props;
        return onnectDropTarget(div({
            className: 'Map',
            ref: (mapElement) => {this.mapElement = mapElement}
        }));
    }
}

export default connect(
    ({
        city,
        style,
        styleParamName,
        layerName,
        startFilter,
        startFilterRadius,
        predictedWorkout,
        sequentialColorScale
    }, props) => {
        return {
            city,
            style,
            styleParamName,
            layerName,
            startFilter,
            startFilterRadius,
            predictedWorkout,
            sequentialColorScale
        };
    },
    (dispatch) => {
        return {
            drop(map, point) {
                dispatch(
                    new DropFilterMarker(
                        map.containerPointToLatLng(point)
                    )
                );
            }
        }
    }
)(DropTarget(
    'FILTER',
    {
        drop(props, monitor, component) {
            component.props.drop(component.map, monitor.getClientOffset());
        }
    },
    (connect, monitor) => {
        return {
            onnectDropTarget: connect.dropTarget()
        }
    }
)(Map));



// WEBPACK FOOTER //
// ./src/Map.js